import React, {Fragment} from 'react';
import CustomSelect from "../../../../../components/select";
import config from "../../../../../config";
import Translate from "../../../../../components/Translate";
import PropTypes from "prop-types";
import MemberStatus from "./MemberStatus";
import ColorIndicator from "../../../../../components-new/ColorIndicator";


const statusesToShow = config.currentStatuses
const statusesToShowTranslated = statusesToShow.map(s => {
    return {
        id: s.id,
        name: s.name,
        value: s.value,
        title: <Translate text={s.name.toLowerCase()}/>
    };
});

const MemberCustomStatus = ({member, updateCurrentStatus}) => {
    const colorIndicator = (currentStatus) => (
            <div>
                <ColorIndicator currentStatus={currentStatus ? currentStatus : config.currentStatusMap.offline}/>
            </div>
        )
    ;
    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            {colorIndicator(member.currentStatus)}
            <CustomSelect
                wrapperStyles={{boxShadow: 'none', display: 'inline-block'}}
                titleStyles={{color: '#09183A'}}
                listStyles={{boxShadow: 'none', width: '170%'}}
                options={statusesToShowTranslated}
                selected={member.currentStatus ? member.currentStatus : config.currentStatusMap.offline}
                handleSelect={updateCurrentStatus}
                width="100px"
            />
        </div>
    );
};

MemberStatus.propTypes = {
    member: PropTypes.object.isRequired,
    updateStatus: PropTypes.func.isRequired,
};

export default MemberCustomStatus;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/MemberCustomStatus.jsx